module.exports = __webpack_public_path__ + "static/media/google_icon.94dcb304.svg";